import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateLearningFormat, ILearningFormatPayload } from "../types";
import { GetDeleteFormat, GetLearningFormat } from "./thunk";

const initialState: IInitialStateLearningFormat = {
    learningFormatData: [],
    selectedFormatIDs: [],
    filteredFormat: [],
    isLoadingLearningFormat: false,
    formatRestoreData: [],
    isViewFormatRestore: false,
};

const learningFormatSlice = createSlice({
    name: "learningFormat",
    initialState,
    reducers: {
        setLearningFormat: (
            state,
            action: PayloadAction<{ data: ILearningFormatPayload[]; defaultLanguage: string }>
        ) => {
            const { data, defaultLanguage } = action.payload;
            state.learningFormatData = data;
            state.filteredFormat = state.learningFormatData.flatMap(data => {
                return data.translations
                    .filter(elem => elem.slug === defaultLanguage && elem.learning_format_id !== undefined)
                    .map(item => ({
                        id: item.learning_format_id as number,
                        abbreviation: item.abbreviation ?? "",
                        name: item.name ?? "",
                        slug: item.slug ?? "",
                    }));
            });
        },

        deletedLearningFormat: (state, action: PayloadAction<number>) => {
            state.learningFormatData = state.learningFormatData.filter(elem => elem.id !== action.payload);
        },

        setIsViewFormatRestore: state => {
            state.isViewFormatRestore = !state.isViewFormatRestore;
        },

        setFormatRestoreData: (state, action) => {
            state.formatRestoreData = action.payload;
        },
        deletedRestoreFormat: (state, action) => {
            state.formatRestoreData = state.formatRestoreData.filter(elem => elem.id !== action.payload);
        },
        setSelectedFormatIDs: (state, action) => {
            state.selectedFormatIDs = action.payload;
        },
    },

    extraReducers(builder) {
        builder
            .addCase(GetLearningFormat.pending, state => {
                state.isLoadingLearningFormat = true;
            })
            .addCase(GetLearningFormat.fulfilled, state => {
                state.isLoadingLearningFormat = false;
            })
            .addCase(GetLearningFormat.rejected, state => {
                state.isLoadingLearningFormat = false;
            })
            .addCase(GetDeleteFormat.pending, state => {
                state.isLoadingLearningFormat = true;
            })
            .addCase(GetDeleteFormat.fulfilled, state => {
                state.isLoadingLearningFormat = false;
            })
            .addCase(GetDeleteFormat.rejected, state => {
                state.isLoadingLearningFormat = false;
            });
    },
});

export const {
    setLearningFormat,
    setSelectedFormatIDs,
    deletedLearningFormat,
    setIsViewFormatRestore,
    setFormatRestoreData,
    deletedRestoreFormat,
} = learningFormatSlice.actions;
export default learningFormatSlice;
